import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const LogsFile = RepositoryFactory.get("logsForPagesRoles");

export default {
    getLogsDetails({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.getLogsDetails(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addLogsDetails({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.addLogsDetails(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editLogsDetails({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.editLogsDetails(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    deleteLogsDetails({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.deleteLogsDetails(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    // table
    getLogsTable({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.getLogsTable(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    addLogsTable({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.addLogsTable(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    editLogsTable({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.editLogsTable(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
    deleteLogsTable({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await LogsFile.deleteLogsTable(
                    payload
                );
                resolve(data);
            } catch (error) {
                console.log(error);
                reject(error);
            }
        });
    },
}